export default __webpack_public_path__ + "static/media/SUPER PROPRE.d0c64991.svg";